/*
 * @copyright 2024 HtmlViewer
 *
 * @author Marius David Wieschollek
 * @license AGPL-3.0
 *
 * This file is part of the HtmlViewer App
 * created by Marius David Wieschollek.
 */

const isPublicElmt = document.getElementById('isPublic')
export default () => !!(isPublicElmt && isPublicElmt.value === '1')